import {
  Create,
  Datagrid,
  Edit,
  List,
  SaveButton,
  SimpleForm,
  TextField,
  TextInput,
  Toolbar,
  EditButton,
  DateField,
  Show,
  SimpleShowLayout,
  RichTextField,
} from "react-admin";
import { Card, CardContent, Typography } from "@mui/material";

export const AlertsList = (props) => {
  return (
    <List {...props}>
      <Datagrid rowClick="show">
        <TextField source="id" />
        <TextField source="title" />
        <TextField source="description" />
        <DateField source="pubDate" label="Date" />
        <EditButton />
      </Datagrid>
    </List>
  );
};

export const AlertsCreate = (props) => {
  return (
    <Create title="Create an Alert" {...props} dir="ltr" redirect="list">
      <SimpleForm>
        <TextInput source="title" label="Title" fullWidth />
        <TextInput source="description" label="Description" multiline minRows={5} fullWidth />
      </SimpleForm>
    </Create>
  );
};

const UserEditToolbar = (props) => (
  <Toolbar {...props}>
    <SaveButton />
  </Toolbar>
);

export const AlertsEdit = (props) => {
  return (
    <Edit {...props}>
      <SimpleForm toolbar={<UserEditToolbar />}>
        <TextInput source="title" label="Title" fullWidth />
        <TextInput
          source="description"
          label="Description"
          multiline
          minRows={5}
          fullWidth />
      </SimpleForm>
    </Edit>
  );
};


export const AlertShow = () => (
  <Show>
    <Card sx={{mx: "auto", p: 2, }}>
      <CardContent>
        <Typography variant="h5" gutterBottom>
          Alert Details
        </Typography>

        <Typography variant="body1">
          <strong>ID:</strong> <TextField source="id" />
        </Typography>

        <Typography variant="h6" sx={{ mt: 2 }}>Title:</Typography>
        <TextField source="title" />

        <Typography variant="h6" sx={{ mt: 2 }}>Description:</Typography>
        <RichTextField source="description" />

        <Typography variant="h6" sx={{ mt: 2 }}>Published Date:</Typography>
        <DateField source="pubDate" />
      </CardContent>
    </Card>
  </Show>
);
